import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '../../node_modules/@angular/common';

@Pipe({
  name: 'TimeFormat'
})
export class TimeFormatPipe extends DatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let fechaformateada;

    if(value){
      fechaformateada=value.replace(" ","T");
    }else{
      fechaformateada=value;
    }
    
    return super.transform(fechaformateada, 'HH:mm:ss');
  }

}


// WEBPACK FOOTER //
// ./src/app/time-format.pipe.ts